import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsAbstractGridComponent } from './cms-abstract-grid.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CmsAbstractGridCardComponent } from './components/cms-abstract-grid-card/cms-abstract-grid-card.component';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';

@NgModule({
  declarations: [CmsAbstractGridComponent, CmsAbstractGridCardComponent],
    imports: [CommonModule, MediaModule, GenericLinkModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        AbstractContentGridContainer: {
          component: CmsAbstractGridComponent,
        },
      },
    }),
  ],
})
export class CmsAbstractGridModule {}
